import { getFaultCodes } from '@/data/faultCodes';

export const FaultCodeService = {
  getDeviceTypes(locale = 'zh') {
    const data = getFaultCodes(locale);
    return data.deviceTypes;
  },

  getCategories(locale = 'zh') {
    const data = getFaultCodes(locale);
    return data.categories;
  },

  getFaultsByDevice(deviceType, locale = 'zh') {
    const data = getFaultCodes(locale);
    return data.faults[deviceType] || [];
  },

  getFaultByCode(code, locale = 'zh') {
    const data = getFaultCodes(locale);
    for (const deviceType of Object.keys(data.faults)) {
      const fault = data.faults[deviceType].find(f => f.code === code);
      if (fault) {
        return { ...fault, deviceType };
      }
    }
    return null;
  },

  getAllFaults(locale = 'zh') {
    return getFaultCodes(locale).faults;
  },

  searchFaults(keyword, locale = 'zh') {
    const data = getFaultCodes(locale);
    const results = [];
    const lowerKeyword = keyword.toLowerCase();

    for (const deviceType of Object.keys(data.faults)) {
      results.push(...data.faults[deviceType].filter(f =>
        f.code.toLowerCase().includes(lowerKeyword) ||
        f.title.toLowerCase().includes(lowerKeyword) ||
        f.description.toLowerCase().includes(lowerKeyword)
      ));
    }
    return results;
  },

  getFaultsByCodes(codes, locale = 'zh') {
    return codes.map(code => this.getFaultByCode(code, locale)).filter(Boolean);
  }
};